<template>
  <div>
    <div class="flex-wrap-c scroll"  :style="{height:scrollHeight}">
      <div v-for="(item,index) in list"  hover-class="bcEE"
           @click="toSongPage" :data-type="item.type" :data-index="item.cataIndex">
        <div class="h90 lh90 ml40 mr40 f32 border-bottom item{item.cataIndex}" >
          {{item.cataIndex}}.{{item.name}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue"
import http from '@/util/http.js'
import '@/css/collet.css'

var vm = vue;
export default {
  name: "collet",
  data() {
    return {
      list:[],
      scrollHeight: 0
    }
  },
  methods: {
    toSongPage: function (e) {
      this.$router.push({
        name: 'songPage',
        query:{
          number:e.currentTarget.dataset.index,
          type:e.currentTarget.dataset.type
        }
      })
    },
    getCollectionList: function () {
      let that = this;
      http.post("/song/getCollectionList",null).then(res=> {
        if (res.code === 0) {
          that.list = res.data;
        }
      });
    }
  },
  mounted(){
    if(!this.$global.isLogin){
      let url = window.location.href;
      let arr = url.split("code=");
      if(arr.length>1){
          this.code = arr[1].split("&")[0];
          this.$global.login(this.code);
          this.nickName = this.$global.nickName;
          this.headUrl = this.$global.headUrl;
        }else{
          http.getWechatCode();
        }
     }else{
      this.getCollectionList();
      this.scrollHeight =  (document.documentElement.clientHeight - 60)+'px'
    }
  },
  created() {
  }
}</script>



// WEBPACK FOOTER //
// src/views/collet.vue